module.exports = __webpack_public_path__ + "img/1gh_Dashboard.6ca27f8c.png";